
const API_URL = "https://api.txoria.org/";

//const API_URL = "http://localhost:8445/";

function getApiUrl(path: string) {
    return API_URL + path;
}

export { getApiUrl };
